import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Star, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-navy-900 text-cream-50 relative overflow-hidden" data-id="element-114">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-800 to-navy-900" data-id="element-115" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-117">
          {/* Left Column: Value Anchoring & Image */}
          <div className="space-y-8 order-2 lg:order-1" data-id="element-118">
            <div className="bg-navy-800/50 border border-red-500/30 rounded-2xl p-6 backdrop-blur-sm" data-id="element-119">
              <p className="text-lg text-cream-200/90 leading-relaxed" data-id="element-120">
                "Si el número sube{' '}
                <span className="text-red-400 font-bold" data-id="element-121">$1,500–$4,000</span>{' '}
                cuando ya avisaste en tu trabajo, ya pagaste inspección, ya
                moviste tu vida… no se siente como un 'detalle'. <br data-id="element-122" />
                <br data-id="element-123" />
                <span className="text-white font-bold italic" data-id="element-124">
                  Se siente como una emboscada.
                </span>
                "
              </p>
            </div>

            <div className="relative" data-id="element-125">
              <div className="absolute inset-0 bg-gold-500/10 blur-3xl rounded-full" data-id="element-126" />
              <img src="https://cdn.magicpatterns.com/uploads/m6edm9okwdZWtRcsRtXryr/heylloyd-image-1770865285128.png" alt="Cash-to-Close Sin Ansiedad Bundle" className="relative w-full max-w-md mx-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-127" />
            </div>
          </div>

          {/* Right Column: Pricing Card */}
          <div className="bg-navy-800 border border-gold-500/30 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden order-1 lg:order-2" data-id="element-128">
            {/* Shine effect */}
            <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-gold-500/20 rounded-full blur-3xl" data-id="element-129" />

            <div className="text-center mb-8" data-id="element-130">
              <h2 className="text-3xl md:text-4xl font-bold font-serif mb-2 text-cream-50" data-id="element-131">
                Toma el control hoy
              </h2>
              <p className="text-lg text-gold-400 font-medium" data-id="element-132">
                Precio especial por tiempo limitado
              </p>
              <p className="text-xs text-cream-200/50 mt-1" data-id="element-133">
                Esta oferta puede cambiar sin previo aviso
              </p>
            </div>

            <div className="flex flex-col items-center justify-between gap-6 mb-10 bg-navy-900/80 p-6 rounded-xl border border-navy-700" data-id="element-134">
              <div className="text-center w-full" data-id="element-135">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-136">
                  Bundle Completo
                </h3>
                <p className="text-sm text-cream-200/60 mb-4" data-id="element-137">
                  PDF + Plantilla + Checklists + Scripts
                </p>
                <div className="w-full h-px bg-navy-700 mb-4" data-id="element-138" />
                <div className="flex items-baseline justify-center gap-3" data-id="element-139">
                  <span className="text-xl text-cream-200/40 line-through" data-id="element-140">
                    $29
                  </span>
                  <span className="text-6xl font-bold text-gold-400" data-id="element-141">
                    $6.36
                  </span>
                </div>
                <div className="mt-3 inline-flex items-center bg-green-500/10 border border-green-500/30 rounded-full px-4 py-1.5" data-id="element-142">
                  <span className="text-green-400 text-sm font-bold" data-id="element-143">
                    Ahorras $22.64 — 78% de descuento
                  </span>
                </div>
                <p className="text-xs text-green-400 font-medium mt-2" data-id="element-144">
                  Pago único. Acceso de por vida.
                </p>
              </div>

              {/* Savings Breakdown */}
              <div className="w-full bg-green-900/30 border border-green-500/30 rounded-lg p-4 mt-2" data-id="element-145">
                <div className="flex items-center justify-between mb-2" data-id="element-146">
                  <span className="text-sm text-cream-200/70" data-id="element-147">
                    Valor real del bundle:
                  </span>
                  <span className="text-sm text-cream-200/50 line-through" data-id="element-148">
                    $97.00
                  </span>
                </div>
                <div className="flex items-center justify-between mb-2" data-id="element-149">
                  <span className="text-sm text-cream-200/70" data-id="element-150">
                    Precio actual:
                  </span>
                  <span className="text-sm text-gold-400 font-bold" data-id="element-151">$6.36</span>
                </div>
                <div className="w-full h-px bg-green-500/20 my-2" data-id="element-152" />
                <div className="flex items-center justify-between" data-id="element-153">
                  <span className="text-sm font-bold text-green-400" data-id="element-154">
                    🎉 Te ahorras:
                  </span>
                  <span className="text-lg font-bold text-green-400" data-id="element-155">
                    $90.64 (93% OFF)
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-4" data-id="element-156">
              <a href="https://www.betterbysteps.com/cart/44194725560413:1" target="_blank" rel="noopener noreferrer" className="w-full bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-lg py-5 rounded-xl shadow-lg shadow-gold-500/20 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center group" data-id="element-157">
                <span data-id="element-158">Descargar Ahora — $6.36</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-159" />
              </a>

              <div className="flex items-center justify-center gap-4 text-xs text-cream-200/50 pt-4" data-id="element-160">
                <div className="flex items-center" data-id="element-161">
                  <Lock className="w-3 h-3 mr-1" data-id="element-162" />
                  Pago 100% Seguro
                </div>
                <div className="flex items-center" data-id="element-163">
                  <ShieldCheck className="w-3 h-3 mr-1" data-id="element-164" />
                  Garantía de Satisfacción
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-navy-700 text-center" data-id="element-165">
              <p className="text-sm text-cream-200/80 italic" data-id="element-166">
                "No es 'información'. Es control."
              </p>
            </div>
          </div>
        </motion.div>

        <div className="text-center mt-16 max-w-3xl mx-auto" data-id="element-167">
          <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-168">
            Compra "Cash-to-Close Sin Ansiedad (USA)" y conviértete en la
            persona que entiende su propio cierre.
          </h3>
          <p className="text-lg text-cream-200/60" data-id="element-169">
            Si quieres llegar al cierre sin sentir que te están moviendo el
            piso, este es tu siguiente paso.
          </p>
        </div>
      </div>
    </section>;
}